import { useEffect } from "react";
import { WEB_APP_URL } from "@/lib/assets";

export default function ExternalRedirect() {
  useEffect(() => {
    window.location.replace(WEB_APP_URL);
  }, []);
  return (
    <div data-testid="redirect-to-app" className="flex min-h-[60vh] items-center justify-center px-5 pt-28 text-center text-sm text-[#B5B8B0]">
      <p>
        Je wordt doorgestuurd naar Waidbook.{" "}
        <a href={WEB_APP_URL} className="text-[#CAA362] underline-offset-4 hover:underline">
          Klik hier als dat niet gebeurt.
        </a>
      </p>
    </div>
  );
}
